import React, { useState, useEffect } from "react";
import ApiCaller from "../../../../api/apiCaller";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Row,
  Col,
  CustomInput,
  Label,
  FormGroup,
  Button,
} from "reactstrap";
import "./index.css";
import { UserImportModalInputProps } from "./type";
import t from "utils/Lang";

const UserImportModal = ({
  isShow,
  onModalToggle,
  onCompleted,
}: UserImportModalInputProps) => {
  const [isModalOpen, setIsModalOpen] = useState<boolean>(isShow);
  const [roles, setRoles] = useState<Array<any>>([]);
  const [zones, setZones] = useState<Array<any>>([]);
  const [selectedFile, setSelectedFile] = useState<any | null>(null);
  const toogleModal = () => {
    setIsModalOpen(!isModalOpen);
    if (onModalToggle) {
      onModalToggle(isModalOpen);
    }
  };
  const downloadTemplate = () => {
    window.location.href =
      "/files/templates/user/lisa_user_import_template.xlsx";
  };
  const onSelectFile = (event: any) => {
    setSelectedFile(event.target.files[0]);
  };
  const getRoles = async () => {
    const res = await ApiCaller.get("brand/roles");
    if (res.result) {
      setRoles(
        res.result.map((role: any) => {
          return { value: role.id, label: role.name };
        })
      );
    }
  };
  const getZones = async () => {
    const res = await ApiCaller.get("zone/");
    if (res?.result) {
      const normalizedZones: any = [];
      res.result.forEach((zone: any) => {
        normalizedZones.push({ label: zone.name, value: zone.id, zone });
      });
      setZones(normalizedZones);
    }
  };
  const submitFile = async () => {
    const formData = new FormData();
    formData.set("file", selectedFile);

    const res = await ApiCaller.post("user/import", formData);
    if (res.status === "ok") {
      const defaulPassword = res.result.password;
      alert(
        `Số user tạo mới: ${res.result.user_create_count}\nSố user cập nhật: ${res.result.user_update_count}\nPassword mặc định của các user mới: ${defaulPassword}`
      );
      if (onCompleted) {
        onCompleted();
        toogleModal();
      }
    } else {
      alert(res.message);
    }
  };
  useEffect(() => {
    getRoles();
    getZones();
  }, []);
  return (
    <Modal isOpen={isShow} size="lg" centered toggle={toogleModal}>
      <ModalHeader toggle={toogleModal}>
        {t().setting_user__import_title}
      </ModalHeader>
      <ModalBody>
        <div>
          <Row>
            <Col xs={12}>
              <FormGroup>
                <Button color="info" size="sm" onClick={downloadTemplate}>
                  {t().setting_user__download_template}
                </Button>
              </FormGroup>
            </Col>
            <Col xs={12}>
              <p>{t().setting_user__role_assign_user}</p>
              <p>{t().setting_user__role_description}</p>
              <ul className="import-user-modal__element-listing">
                {roles.map((role) => (
                  <li key={role.label}>{role.label}</li>
                ))}
              </ul>
            </Col>
            <Col xs={12}>
              <p>{t().setting_user__zone_assign_user}</p>
              <p>{t().setting_user__zone_description}</p>
              <ul className="import-user-modal__element-listing">
                {zones.map((zone) => (
                  <li key={zone.label}>{zone.label}</li>
                ))}
              </ul>
            </Col>
            <Col xs={12}>
              <FormGroup>
                <Label for="select-user-list-file">
                  {t().setting_user__select_file_import}
                </Label>
                <CustomInput
                  type="file"
                  id="select-user-list-file"
                  name="select-user-list-file"
                  onChange={(event: any) => onSelectFile(event)}
                />
              </FormGroup>
            </Col>
          </Row>
        </div>
      </ModalBody>
      <ModalFooter>
        <Button color="primary" onClick={submitFile}>
          {t().setting_user__upload_create_user}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default UserImportModal;
